<app-bread-crumbs
  [navigationRoute]="currentRoute"
  [currentPageString]="currentPageString"
  [clickHandler]="returnToRFQ"
  [breadCrumbFlow]="breadCrumbFlow" [activePage]="activePage"
>
</app-bread-crumbs>
<div class="page-container">
  <app-layout class="container--form">
    <div *ngIf="isLoading">
      <mat-spinner class="mydocs-spinner" ></mat-spinner>
      <div class="mydocs-spinner-text paragraph-medium-regular"><p>Retrieving data...</p></div>
    </div>
    <div class="output-history-container" *ngIf="!isLoading">
      <app-add-reference-card
        desc="You have no output history item."
        *ngIf="dataSource.data.length < 1">
      </app-add-reference-card>
      <div class="table-wrapper">
        <table
          class="mat-elevation-z3 table-content"
          mat-table
          multiTemplateDataRows
          matSort
          [dataSource]="dataSource"
          *ngIf="dataSource.data.length > 0">
          <ng-container matColumnDef="{{ column }}" *ngFor="let column of columnsToDisplay">
            <div *ngIf="column === 'VersionNumber'">
              <th mat-header-cell *matHeaderCellDef> Version </th>
            </div>
            <div *ngIf="column === 'Type'">
              <th mat-header-cell *matHeaderCellDef>Output</th>
            </div>
            <div *ngIf="column === 'RFQNumber'">
              <th mat-header-cell *matHeaderCellDef>RFQ Number</th>
            </div>
            <div *ngIf="column === 'Name'">
              <th mat-header-cell *matHeaderCellDef>Vendor Name</th>
            </div>
            <div *ngIf="column === 'Email'">
              <th mat-header-cell *matHeaderCellDef> Email ID </th>
            </div>
            <div *ngIf="column === 'ModifiedOn'">
              <th mat-header-cell *matHeaderCellDef> Output datetime</th>
            </div>
            <div *ngIf="column === 'RFQDeadline'">
              <th mat-header-cell *matHeaderCellDef> RFQ deadline</th>
            </div>
            <div *ngIf="column === 'CreatedBy'">
              <th mat-header-cell *matHeaderCellDef> Personnel</th>
            </div>
            <div *ngIf="column === 'TempStatus'">
              <th mat-header-cell *matHeaderCellDef> Status</th>
            </div>
            <div *ngIf="column === 'TempReason'">
              <th mat-header-cell *matHeaderCellDef> Reason</th>
            </div>
            <div>
              <th mat-header-cell *matHeaderCellDef> {{ formatHeader(column) }} </th>
            </div>
            <div *ngIf="column === 'VersionNumber'">
              <td class="active" (click)="onDownloadZip(element.MPDocumentNumber, element.VendorNumber, element.RFQNumber, element.VersionNumber)" mat-cell *matCellDef="let element">{{ element[column] }}</td>
            </div>
            <div *ngIf="column === 'ModifiedOn' || column === 'RFQDeadline'">
              <td mat-cell *matCellDef="let element">{{ element[column] | date: 'dd-MMM-yy, h:mm a'}}</td>
            </div>
            <div *ngIf="column !== 'VersionNumber' && column !== 'ModifiedOn' && column !== 'RFQDeadline'">
              <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
            </div>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
        </table>
      </div>
      <mat-paginator [ngClass]="{'d-none': dataSource.data.length < 1}" [length]="dataSource.data.length" [pageSizeOptions]="pageSizeOptions"  showFirstLastButtons></mat-paginator>
    </div>
  </app-layout>
</div>
